import { render, staticRenderFns } from "./cityselect.vue?vue&type=template&id=154cb815&scoped=true&"
import script from "./cityselect.vue?vue&type=script&lang=js&"
export * from "./cityselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154cb815",
  null
  
)

export default component.exports